import React from 'react';
import { View } from '@gin-betting/core';

import LogoTitle from '../LogoTitle';
import './teamsTitle.scss';

interface Props {
    competitorsValid: View.CompetitorsValid;
    linkToMatch: string | null;
    sportId: string;
}

const TeamsTitle: React.FC<Props> = ({
    competitorsValid: { awayLogo, awayName, homeLogo, homeName },
    linkToMatch,
    sportId,
}) => {
    return (
        <div styleName="container" className="__app-TeamsTitle-container">
            <LogoTitle
                sportId={sportId}
                logoUrl={homeLogo}
                name={homeName}
                isLogoBeforeTeamName={true}
                linkToMatch={linkToMatch}
            />
            <div styleName="draw" className="__app-TeamsTitle-draw">
                {/* <FormattedMessage {...globalMessages.draw} /> */}X
            </div>
            <LogoTitle
                sportId={sportId}
                logoUrl={awayLogo}
                name={awayName}
                isLogoBeforeTeamName={true}
                linkToMatch={linkToMatch}
            />
        </div>
    );
};

export default TeamsTitle;
